module.exports = __webpack_public_path__ + "kibervarnost/media/ne-verjemi-velikim-obljubam.150f0d77.webm";